import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { GridApi } from 'ag-grid-enterprise'
import { EnhancedDriverData } from '../types/driverData'

export const useDriverDataExcelExport = (gridApi: GridApi<EnhancedDriverData> | undefined) => {
  const { t } = useTranslation()

  const handleExportToExcel = useCallback(() => {
    if (!gridApi) return

    const fileName = `${t('entity:budgetDriver')}.xlsx`

    gridApi.exportDataAsExcel({
      fileName,
      skipColumnGroupHeaders: true,
      allColumns: false,
      sheetName: t('entity:budgetDriver'),
      processCellCallback: params => {
        const colDef = params.column.getColDef()

        // For text columns (formulaId, dimensionId), use valueFormatter to get names instead of IDs
        if (colDef.cellDataType === 'text' && colDef.valueFormatter && typeof colDef.valueFormatter === 'function') {
          // Create ValueFormatterParams from ProcessCellForExportParams
          const formatterParams = {
            value: params.value,
            data: params.node?.data,
            colDef,
            node: params.node ?? null,
            column: params.column,
            api: params.api,
            context: params.context
          }
          return colDef.valueFormatter(formatterParams)
        }

        // For number columns, return raw value (no formatting, no thousand separators)
        if (colDef.cellDataType === 'number') {
          return params.value ?? ''
        }

        return params.value ?? ''
      }
    })
  }, [gridApi, t])

  return handleExportToExcel
}
